import { app } from '../../../../app';
import { Controller } from './add.controller';

app.component('addUserEmail', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/add/add.component.js